<div class="content">
    <div left-panel>
        <crypto-assets-total></crypto-assets-total>
    </div>
    <div right-panel></div>
</div>